import { MenuDesignTokens } from '@primeuix/themes/types/menu';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { t, tDeep } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/menu/index.ts
const menu = componentCommon.menu;
const menuDeep = tDeep(menu);

export const MenuTelekomDT: MenuDesignTokens = {
  root: {
    background: t(menu.background),
    borderColor: t(menu.border.color),
    color: t(menu.color),
    borderRadius: t(menu.border.radius),
  },
  list: {
    padding: `${menuDeep.list.padding.y} ${menuDeep.list.padding.x}`,
    gap: t(menu.list.gap),
  },
  item: {
    focusBackground: t(menu.item.focus.background),
    color: t(menu.item.color),
    focusColor: t(menu.item.focus.color),
    padding: `${menuDeep.item.padding.y} ${menuDeep.item.padding.x}`,
    borderRadius: t(menu.item.border.radius),
    gap: t(menu.item.gap),
    icon: {
      color: t(menu.item.icon.color),
      focusColor: t(menu.item.icon.focus.color),
    },
  },
  submenuLabel: {
    padding: `${menuDeep.submenu.label.padding.y} ${menuDeep.submenu.label.padding.x}`,
    fontWeight: t(menu.submenu.label.font.weight),
    background: t(menu.submenu.label.background),
    color: t(menu.submenu.label.color),
  },
  separator: {
    borderColor: t(menu.separator.border.color),
  },
};
